import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule }   from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';

import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { PlatformModule } from '@angular/cdk/platform';
import { GoogleChartsModule, ScriptLoaderService } from 'angular-google-charts';

import { AppComponent } from './app.component';
// import { HeaderComponent }   from './components/common/header/header.component';
// import { WrapperComponent }   from './components/routes/wrapper/wrapper.component';
// import { SidenavComponent }   from './components/common/sidenav/sidenav.component';
// import { ListComponent }   from './components/routes/list/list.component';
// import { ViewComponent }   from './components/routes/view/view.component';
// import { EditComponent, EditErrorMessageComponent }   from './components/routes/edit/edit.component';
// import { ReportComponent }   from './components/routes/report/report.component';

// import { VideoQuestionnaireEditComponent }   from './components/routes/video-questionnaire/edit/edit.component';
// import { VideoQuestionnaireReportComponent }   from './components/routes/video-questionnaire/report/report.component';

// import { VideoPartComponent } from 'src/app/components/common/part/video-part/video-part.component';
// import { ContentListPartComponent } from 'src/app/components/common/part/content-list-part/content-list-part.component';
// import { QuestionPartComponent } from 'src/app/components/common/part/content/question-part/question-part.component';
// import { CtaSimplePartComponent } from 'src/app/components/common/part/content/cta-simple-part/cta-simple-part.component';
// import { MessageSimplePartComponent } from 'src/app/components/common/part/content/message-simple-part/message-simple-part.component';
// import { FormOverlayPartComponent } from 'src/app/components/common/part/content/form-overlay-part/form-overlay-part.component';
// import { StartPartComponent } from 'src/app/components/common/part/start-part/start-part.component';
// import { EndPartComponent } from 'src/app/components/common/part/end-part/end-part.component';
// import { AddPartComponent } from 'src/app/components/common/part/add-part/add-part.component';

// Player Components //////////////////////////
import { PlaylistComponent } from 'src/app/components/oneroll-player/playlist/playlist.component';
import { PlayerComponent } from 'src/app/components/oneroll-player/player/player.component';
import { QuestionComponent } from 'src/app/components/oneroll-player/question/question.component';
import { CtaSimpleComponent } from 'src/app/components/oneroll-player/cta-simple/cta-simple.component';
import { CtaSimpleExpandComponent } from 'src/app/components/oneroll-player/cta-simple/cta-simple-expand/cta-simple-expand.component';
import { MessageSimpleComponent } from 'src/app/components/oneroll-player/message-simple/message-simple.component';
import { StatisticsComponent } from 'src/app/components/oneroll-player/statistics/statistics.component';
import { RecommendComponent } from 'src/app/components/oneroll-player/recommend/recommend.component';
import { FormOverlayComponent } from 'src/app/components/oneroll-player/form-overlay/form-overlay.component';
import { FormExpandComponent } from 'src/app/components/oneroll-player/form-expand/form-expand.component';
import { PasswordComponent } from 'src/app/components/oneroll-player/password/password.component';

import { ErrorComponent } from 'src/app/components/oneroll-player/error/error.component';

// import { DialogVideoListComponent } from 'src/app/components/common/dialog/dialog-video-list/dialog-video-list.component';
// import { DialogContentComponent } from 'src/app/components/common/dialog/dialog-content/dialog-content.component';
// import { DialogContentPlayerComponent } from 'src/app/components/common/dialog/dialog-content/dialog-content-player/dialog-content-player.component';
// import { DialogPreviewComponent } from 'src/app/components/common/dialog/dialog-preview/dialog-preview.component';
// import { DialogTitleEditComponent } from 'src/app/components/common/dialog/dialog-title-edit/dialog-title-edit.component';

// import { MatPaginatorIntlJa } from 'src/app/languages/mat-paginator-intl-ja';

import { VideoService } from 'src/app/services/video.service';
import { FormService } from 'src/app/services/form.service';
import { BaseService } from 'src/app/services/base.service';
import { GaService } from 'src/app/services/ga.service'; // google analytics

// import { SidenavService } from 'src/app/services/sidenav.service';
// import { ConfigService } from 'src/app/services/config.service';
// import { PlaylistEditorService } from 'src/app/services/playlist-editor.service';

// Pipe
// import { MinSec } from 'src/app/pipes/minsec';
import { HourMinSec } from 'src/app/pipes/hourminsec';
import { Linky } from 'src/app/pipes/linky';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html';

@NgModule({
  declarations: [
    AppComponent,
    // HeaderComponent,
    // WrapperComponent,
    // SidenavComponent,
    // ListComponent,
    // ViewComponent,
    // EditComponent, EditErrorMessageComponent,
    // ReportComponent,

    // VideoQuestionnaireEditComponent,
    // VideoQuestionnaireReportComponent,
    
    // VideoPartComponent,
    // ContentListPartComponent,
    // QuestionPartComponent,
    // CtaSimplePartComponent,
    // MessageSimplePartComponent,
    // FormOverlayPartComponent,
    // StartPartComponent,
    // EndPartComponent,
    // AddPartComponent,

    // DialogVideoListComponent,
    // DialogContentComponent,
    // DialogContentPlayerComponent,
    // DialogPreviewComponent,
    // DialogTitleEditComponent,

    PlaylistComponent,
    PlayerComponent,
    QuestionComponent,
    CtaSimpleComponent,
    CtaSimpleExpandComponent,
    MessageSimpleComponent,
    StatisticsComponent,
    RecommendComponent,
    FormOverlayComponent,
    FormExpandComponent,
    PasswordComponent,

    ErrorComponent,

    // MinSec,
    HourMinSec,
    Linky,
    SafeHtmlPipe,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    // AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatIconModule,
    MatMenuModule,
    MatDialogModule,
    MatSelectModule,
    MatPaginatorModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatStepperModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatSidenavModule,
    MatToolbarModule,
    MatTableModule,
    MatCheckboxModule,
    DragDropModule,
    PlatformModule,
    GoogleChartsModule,
    RouterModule.forRoot([]),
  ],
  entryComponents: [
    // DialogVideoListComponent,
    // DialogContentComponent,
    // DialogPreviewComponent,
    // DialogTitleEditComponent,
    // EditErrorMessageComponent,
  ],
  providers: [
    // { provide: MatPaginatorIntl, useClass: MatPaginatorIntlJa },
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    ScriptLoaderService,

    BaseService,
    VideoService,
    FormService,
    GaService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


